import { ChangeDetectionStrategy, Component, OnInit, inject } from '@angular/core';

import { StatisticsResource } from '../../../services/resources/statistics.resource';

@Component({
    selector: 'sl-total-shareholders',
    templateUrl: './total-shareholders.component.html',
    styleUrls: ['./total-shareholders.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TotalShareholdersComponent implements OnInit {
    label: string;
    amount: number;

    private readonly statisticsResource = inject(StatisticsResource);

    ngOnInit(): void {
        this.statisticsResource.getTotalShareholders().subscribe(r => {
            this.label = r.value.label;
            this.amount = r.value.value;
        });
    }
}
